/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Tour_Search_BodyInputs */



/**
* | output |
* | --- |
* | "Find chats, files, projects and spaces from anywhere. Ctrl+K or ⌘K opens it." |
*
* @param {Onboarding_Tour_Search_BodyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const onboarding_tour_search_body = /** @type {((inputs?: Onboarding_Tour_Search_BodyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Tour_Search_BodyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Finde Chats, Dateien, Projekte und Spaces von überall. Strg+K oder ⌘K öffnet sie.")
	return /** @type {LocalizedString} */ ("Find chats, files, projects and spaces from anywhere. Ctrl+K or ⌘K opens it.")
});